<div class="vr-modal-backdrop" *ngIf="open" (click)="close()">
  <div class="vr-modal" role="dialog" aria-modal="true" aria-labelledby="vr-modal-title"
       (click)="$event.stopPropagation()">
    <header class="vr-modal__header">
      <h3 id="vr-modal-title">Please verify your email</h3>
      <button type="button" class="vr-modal__close" aria-label="Close" (click)="close()">×</button>
    </header>
    <div class="vr-modal__body">
      <p>
        To continue, confirm your email address. We sent a link to the email you signed up with.
        Didn’t get it?
      </p>
      <p class="vr-modal__hint">Check your spam folder or click resend below.</p>
      <p class="vr-modal__msg" *ngIf="message">{{ message }}</p>
    </div>
    <footer class="vr-modal__footer">
      <button type="button" class="vr-modal__secondary" (click)="close()">Not now</button>
      <button type="button" class="vr-modal__primary"
              [disabled]="sending"
              (click)="resend()">
        {{ sending ? 'Sending…' : 'Resend email' }}
      </button>
    </footer>
  </div>
</div>
